export enum ParameterTypeValueEnum {
	Integer = 1,
	Decimal = 2,
	Boolean = 3,
	String = 4,
	SignedInteger = 5,
	SignedDecimal = 6,
}
